{
  "goal": "Goal",
  "subAccount": "Sub-account",
  "household": "Household",
  "any": "Any",
  "table": {
    "client": "Client",
    "type": "Model Portfolio Type",
    "goal": "Goal",
    "accounts": "Account(s)",
    "portfolioValue": "Portfolio value",
    "driftRebalanceRequired": "Drift Trigger",
    "internalDriftTrigger": "Internal Drift Trigger",
    "liquidateRebalanceRequired": "Liquidation Trigger",
    "cashTrigger": "Cash Trigger",
    "tradeRequests": "Trade Requests",
    "updatedAt": "Last Updated",
    "organization": "Organization",
    "cashAvailableForTrade": "Cash Available For Trade",
    "expectedCash": "Expected Cash",
    "pendingCash": "Pending Cash",
    "difference": "Difference Required",
    "cashPercentage": "Cash Percentage",
    "portfolio": "Model Portfolio",
    "totalMarketValue": "Total Market Value",
    "tradeVerificationRequired": "Trade Verification Required",
    "bulkTradeRequired": "Bulk Trade Required"
  },
  "tooltips": {
    "cashAvailableForTrade": "This is your cash less trades that are in processing state",
    "pendingCash": "This is your pending cash",
    "UNPAIRED": "Trades requested",
    "ILLIQUID": "Illiquid product",
    "UNBLOCKED_BUYS": "Unblocked buys",
    "PAIRED": "Paired"
  },
  "types": {
    "GOAL": "Goal",
    "SUB_ACCOUNT": "Sub-account",
    "HOUSEHOLD": "Household"
  },
  "goalType": {
    "CAR": "Car",
    "BUILD_WEALTH": "Build Wealth",
    "RETIREMENT": "Retirement",
    "MAJOR_PURCHASE": "Major Purchase",
    "HOUSE": "House",
    "EDUCATION": "Education",
    "VACATION": "Vacation",
    "START_A_BUSINESS": "Start a Business",
    "WEDDING": "Wedding",
    "PARENTAL_LEAVE": "Parental Leave",
    "SAFETY_NET": "Safety Net",
    "OTHER": "Other",
    "CASH_RESERVE": "Cash Reserve",
    "LEGACY": "Legacy",
    "GROUP": "Group",
    "RETIREMENT_INCOME": "Retirement Income"
  },
  "filters": {
    "selectOrganization": "Select Organization",
    "modalportfolioType": "Model Portfolio Type",
    "selectPortfolio": "Select Model Portfolio",
    "selectAccountType": "Select AccountType",
    "selectAccount": "Select Account",
    "triggerType": "Trigger Type",
    "driftRebalance": "Drift",
    "internalDrift": "Internal Drift",
    "cash": "Cash",
    "liquidateRebalance": "Liquidation Rebalance Only",
    "anyRebalanceRequired": "Rebalance Required",
    "tradeRequests": "Trade Requests",
    "yes": "Yes",
    "no": "No",
    "bulkTradeRequiredReason": "Bulk Trade Required Reason",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "value": "Value",
    "zero": "$0",
    "greaterThanZero": "Greater Than $0",
    "tradeVerificationStatus": "Trade Verification Status",
    "verified": "Verified",
    "unverified": "Unverified"
  }
}
